const yoflags = require('@yola/yoflagsjs');
const config = require('../helpers/config');

const AI_LOCALIZATION_FEATURE = 'ai-localization';
const COMPOSITE_GROUP_FEATURE = 'composite-group';

const hideFeaturesUnderFeatureFlags = async (isUserUnauthorized) => {
  const apiUrl = config.get('publicApi');
  let isAiLocalizationEnabled = false;
  let isCompositeGroupEnabled = false;

  try {
    const { visitorFlags, userFlags } = await yoflags.initWith(apiUrl);

    if (isUserUnauthorized) {
      const { data } = await visitorFlags();
      const { ai_localization: aiLocalization, composite_group: compositeGroup } = data;

      isAiLocalizationEnabled = aiLocalization || false;
      isCompositeGroupEnabled = compositeGroup || false;
    } else {
      // as we use http protocol to run yolacom localy this request
      // does not work localy because of Yola cookie Secure
      const [
        {
          data: {
            data: { ai_localization: aiLocalization }
          }
        },
        {
          data: {
            data: { composite_group: compositeGroup }
          }
        }
      ] = await Promise.all([
        userFlags('ai_localization'),
        userFlags('composite_group'),
      ]);

      isAiLocalizationEnabled = aiLocalization || false;
      isCompositeGroupEnabled = compositeGroup || false;
    }
  } catch (error) {
    console.error(error);
  }

  const features = [
    {
      enabled: isAiLocalizationEnabled,
      name: AI_LOCALIZATION_FEATURE,
    },
    {
      enabled: isCompositeGroupEnabled,
      name: COMPOSITE_GROUP_FEATURE,
    }
  ];

  features.forEach((feature) => {
    if (!feature.enabled) {
      const featureElements = document.querySelectorAll(`[data-yola-feature="${feature.name}"]`);

      featureElements.forEach((element) => element.remove());
    }
  });
};

module.exports = hideFeaturesUnderFeatureFlags;
